module.exports = {"theMovieDBAPIKey":"d1d3a06b746f2757f286808867e20d91"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 467
// module chunks = 0